
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { resources } from './local';

// Get saved language or default to Spanish
const savedLanguage = localStorage.getItem('language') || 'es';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'es', // Default to Spanish
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
